//cspell: words adbreak
export var TelemetryEventType = /*#__PURE__*/ function(TelemetryEventType) {
    TelemetryEventType["AdBreakStart"] = "ADBREAK_START";
    TelemetryEventType["AdBreakEnd"] = "ADBREAK_END";
    TelemetryEventType["AdBreakError"] = "ADBREAK_ERROR";
    TelemetryEventType["EndError"] = "END_ERROR";
    TelemetryEventType["Periodic"] = "PERIODIC";
    return TelemetryEventType;
}({});
export var TelemetryNotificationKey = /*#__PURE__*/ function(TelemetryNotificationKey) {
    TelemetryNotificationKey["sessionStart"] = "sessionStart";
    TelemetryNotificationKey["videoStartUp"] = "videoStartUp";
    TelemetryNotificationKey["vacRequestStart"] = "vacRequestStart";
    TelemetryNotificationKey["vacResponseEnd"] = "vacResponseEnd";
    TelemetryNotificationKey["ovpRequestStart"] = "ovpRequestStart";
    TelemetryNotificationKey["ovpResponseEnd"] = "ovpResponseEnd";
    TelemetryNotificationKey["mediaTailorRequestStart"] = "mediaTailorRequestStart";
    TelemetryNotificationKey["mediaTailorResponseEnd"] = "mediaTailorResponseEnd";
    TelemetryNotificationKey["trackingUrlRequestStart"] = "trackingUrlRequestStart";
    TelemetryNotificationKey["trackingUrlResponseEnd"] = "trackingUrlResponseEnd";
    return TelemetryNotificationKey;
}({});

//# sourceMappingURL=telemetry.enums.js.map